export const CHEMISTRY_LAB_PATH = '/labs/chemistry';
export const CHEMISTRY_LAB_RETURNS = {
  learn: '/learn',
  chemistry: '/learn/study/subjects/chemistry/tools',
  portal: '/portal/more',
  guest: '/learn/login',
} as const;

/** Lab deep links (lab `src/main.tsx`): one experiment card, or the experiment list. */
const CARD_ID = /^[a-z0-9][a-z0-9-]{0,63}$/;

export function chemistryLabYear(year: string | null): string | null {
  return year && /^(?:[6-9]|1[0-2]|all)$/.test(year) ? year : null;
}

export function chemistryLabCard(card: string | null): string | null {
  return card && CARD_ID.test(card) ? card : null;
}

/** The pinned lab entry, with only an allowlisted deep link passed through. */
export function chemistryLabFrameSrc(
  entry: string,
  card: string | null,
  view: string | null,
): string {
  const validCard = chemistryLabCard(card);
  if (validCard) return `${entry}?${new URLSearchParams({ card: validCard })}`;
  return view === 'experiments' ? `${entry}?view=experiments` : entry;
}

export function chemistryLabReturn(from: string | null, year: string | null = null): string {
  const destination =
    from && Object.prototype.hasOwnProperty.call(CHEMISTRY_LAB_RETURNS, from)
      ? CHEMISTRY_LAB_RETURNS[from as keyof typeof CHEMISTRY_LAB_RETURNS]
      : CHEMISTRY_LAB_RETURNS.guest;
  const selectedYear = chemistryLabYear(year);
  return from === 'chemistry' && selectedYear ? `${destination}?year=${selectedYear}` : destination;
}

/** A direct/reloaded public Lab has not restored HttpOnly sessions yet. */
export function chemistryLabNeedsSessionRestore(
  destination: string,
  tokens: Readonly<{ kid: string | null; user: string | null }>,
): boolean {
  const path = destination.split('?')[0];
  if (path === CHEMISTRY_LAB_RETURNS.learn || path === CHEMISTRY_LAB_RETURNS.chemistry)
    return !tokens.kid;
  if (path === CHEMISTRY_LAB_RETURNS.portal) return !tokens.user;
  return false;
}
